import React, { useEffect, useState } from 'react';
import Banner from '../../../components/Banner';
import { Container, Row } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTourList } from './action';

import TourThumbnail from '../../../components/thumbnail/TourThumbnail';

import searchIcon from '../../../assets/img/icon/search.svg';
import './style.scss';

const Tourism = ({ history, i18n, getTourList, tourList }) => {
  const { data } = tourList || {};
  const [search, changeSearch] = useState('');

  useEffect(() => {
    getTourList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Banner
        title={i18n('news.heading.top1')}
        subtitle={i18n('news.heading.top2')}
        backButtonClick={() => history.goBack()}
      />
      <Container>
        <div className='tourism'>
          <div className='tourism-top'>
            <h3>{i18n('news.heading.list')}</h3>
            <div className='tourism-top-search'>
              <img src={searchIcon} alt='search-img' />
              <input
                placeholder={i18n('news.search')}
                onChange={(e) => changeSearch(e.target.value)}
              />
            </div>
          </div>
          <div className='tourism-list'>
            <Row>
              {data.map((tour, key) =>
                tour.title.toLowerCase().includes(search) ? (
                  <TourThumbnail key={key} data={tour} history={history} />
                ) : (
                  ''
                )
              )}
            </Row>
          </div>
          <div className='tourism-paginate' style={{ display: 'none' }}>
            <div className='prev'>{i18n('nav.prev')}</div>
            <div className='number'>1</div>
            <div className='number active'>2</div>
            <div className='number'>3</div>
            <div className='next'>{i18n('nav.next')}</div>
          </div>
        </div>
      </Container>
    </>
  );
};

Tourism.propTypes = {
  history: PropTypes.any,
  i18n: PropTypes.func,
  getTourList: PropTypes.func,
  tourList: PropTypes.object
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n,
  tourList: {
    status: state.tourListReducer.status,
    error: state.tourListReducer.error,
    data: state.tourListReducer.data
  }
});

export default compose(connect(mapStateToProps, { getTourList }), withRouter)(Tourism);
